
<template>
  <div class="edit-div"
         v-html="innerText"
         :contenteditable="canEdit"
         @input="changeText">
    </div>


</template>    
    
    <script>
     export default{
        name: 'editdiv',
        props: {
            value: {
                type: String,
                default: ''
            },
            canEdit: {
                type: Boolean,
                default: true
            }
        },
        data(){
            return {
                innerText: this.value,
                isLocked: false
            }
        },
        watch: {
            'value'(){
                if (!this.isLocked || !this.innerText) {
                    this.innerText = this.value;
                }
            }
        },
        methods: {
            changeText(){
                this.$emit('input', this.$el.innerHTML);
            }
        }
    }
    </script>
   


// WEBPACK FOOTER //
// src/components/chatPlaza/emotions/editdiv.vue